import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    logList: [],
    pagination: {
      page: 1,
      size: 25
    },
    totalCount: 0
  },
  mutations: {
    setLogList(state, payload) {
      state.logList = payload;
    },
    setTotalCount(state, payload) {
      state.totalCount = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    list({ commit }, params) {
      commit('setPagination', { page: params.page, size: params.size });

      api.list(params).then(({ data }) => {
        commit('setLogList', data.list);
        commit('setTotalCount', data.totalCount);
      });
    }
  }
};

appStore.registerModule('apiLog', store);
